import { getSession } from './session.ts';

function buildHeaders(defaults: Record<string, string> = {}) {
  const session = getSession();
  const headers: Record<string, string> = {
    Accept: 'application/json',
    ...defaults,
  };
  if (session?.otp) {
    headers['X-OTP'] = session.otp;
  }
  return headers;
}

function errorMessage(data: any) {
  if (typeof data?.error === 'string') return data.error;
  if (Array.isArray(data?.errors)) return data.errors.join('. ');
  if (typeof data?.errors === 'string') return data.errors;
  return 'Erro na requisição';
}

async function parseResponse<T>(response: Response): Promise<T> {
  let data: any = null;
  try {
    data = await response.json();
  } catch {
    if (!response.ok) throw new Error(`Erro na requisição (${response.status})`);
    throw new Error('Resposta inválida do servidor');
  }

  if (!response.ok) {
    throw new Error(errorMessage(data));
  }

  return data as T;
}

export async function getJson<T>(path: string): Promise<T> {
  const response = await fetch(path, {
    headers: buildHeaders(),
  });

  return parseResponse<T>(response);
}

export async function postJson<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(path, {
    method: 'POST',
    headers: buildHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  });

  return parseResponse<T>(response);
}

export async function postFormData<T>(path: string, formData: FormData): Promise<T> {
  const response = await fetch(path, {
    method: 'POST',
    headers: buildHeaders(),
    body: formData,
  });

  return parseResponse<T>(response);
}
